var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M40,6H24l-2,4L10,21l-4,2v17c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V8C42,6.895,41.105,6,40,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8e6c9",
    d: "M38 38L10 38 10 21 22 10 38 10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#26662b",
    d: "M6,23c0,0,1.673,0.198,4,0.469V21L6,23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5d6a7",
    d: "M10,21v2.469C15.069,24.061,23.243,25,24,25c1.105,0,2-0.895,2-2c0-0.745-0.909-8.213-1.502-13H22 L10,21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#26662b",
    d: "M22,10h2.498C24.213,7.689,24,6,24,6L22,10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc02d",
    d: "M24,6v15c0,1.1-0.9,2-2,2H6l4.3-4.06l9.85-9.3L24,6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0288d1",
    d: "M21,13c0,3.87-3.13,7-7,7c-1.36,0-2.63-0.39-3.7-1.06l9.85-9.3C20.69,10.64,21,11.78,21,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsocial);
export default __webpack_public_path__ + "static/media/esocial.729b7cfa4931bdb65ba02f7fc20c798e.svg";
export { ForwardRef as ReactComponent };